import Breadcrumb from "components/Common/Breadcrumb2"
import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { withTranslation } from "react-i18next"
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Row,
  Spinner,
  UncontrolledTooltip,
} from "reactstrap"

import {
  deleteFactory,
  getAllFactoriesParanoid,
  restoreFactory,
  updateFactory,
  postNovaFactory,
} from "services/factoires/calls.js"

import toast from "components/Toast/Toast"
import BootstrapTable from "react-bootstrap-table-next"
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"

const Fabricas = props => {
  document.title = "Cadastro de Fábricas | Sensetek"
  moment.locale("pt-br")
  const { t } = props

  const [isLoading, setIsLoading] = useState(true)
  const [fabricas, setFabricas] = useState()
  const [novaFabrica, setNovaFabrica] = useState({
    name: "",
    // tag: "",
    sla: "",
    slaAlertEnabled: false,
  })
  const [updatedFabrica, setUpdatedFabrica] = useState({
    name: "",
    // tag: "",
    sla: "",
    slaAlertEnabled: false,
  })

  const [confirm, setConfirm] = useState({})
  const [showConfirm, setShowConfirm] = useState(false)
  const [modalUpdatedFabrica, setModalUpdatedFabrica] = useState(false)

  const selectRow = {
    mode: "checkbox",
    hideSelectColumn: true,
  }

  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]

  const columns = [
    {
      dataField: "id",
      text: "#",
      sort: false,
      headerStyle: {
        width: "50px",
      },
      formatter: (cellContent, row) => <b>{cellContent}</b>,
    },
    {
      dataField: "name",
      text: "Nome",
      sort: false,
    },
    {
      dataField: "sla",
      text: "Sla",
      sort: false,
      headerAlign: "center",
      align: "center",
    },
    {
      dataField: "slaAlertEnabled",
      text: "Alerta Sla",
      sort: false,
      headerAlign: "center",
      align: "center",
      formatter: (cellContent, row) => (cellContent ? "Sim" : "Não"),
    },
    {
      dataField: "actions",
      isDummyField: true,
      text: "Ações",
      headerAlign: "center",
      align: "center",
      headerStyle: (colum, colIndex) => {
        return { width: "10%", textAlign: "center" }
      },
      formatter: (cellContent, row) => (
        <ul className="list-unstyled hstack gap-1 mb-0 justify-content-center">
          <li>
            <a
              href={`/configuracoes/sla/fabricas/${row.id}`}
              className={`btn btn-sm btn-warning`}
            >
              <i className="mdi mdi-truck" id={`embossing${row.id}`}></i>
            </a>
            <UncontrolledTooltip placement="top" target={`embossing${row.id}`}>
              SLA
            </UncontrolledTooltip>
          </li>
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-primary`}
              onClick={() => {
                setUpdatedFabrica(row)
                setModalUpdatedFabrica(true)
              }}
            >
              <i
                className="mdi mdi-account-edit"
                id={`altToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`altToolTip${row.id}`}>
              Alterar
            </UncontrolledTooltip>
          </li>
          <li>
            <a
              target="_blank"
              className={`btn btn-sm btn-${
                row.deletedAt ? "secondary" : "danger"
              }`}
              onClick={async () => {
                if (row.deletedAt) {
                  try {
                    setIsLoading(true)
                    await restoreFactory(row.id)
                    fetchAllFabricas()
                    toast("success", "Fábrica ativada com sucesso!")
                  } catch (error) {
                    toast("warning", "Falha ao ativar Fábrica.")
                    console.log(error)
                  } finally {
                    setIsLoading(false)
                  }
                } else {
                  setConfirm({
                    title: "Confirmação",
                    body: (
                      <div>
                        <p>Esta ação ira desabilitar esta opção de Fábrica.</p>
                        <p>
                          Por favor, confirme se tem certeza que deseja
                          desabilitar este Fábrica?
                        </p>
                      </div>
                    ),
                    onConfirm: async () => {
                      setIsLoading(true)
                      try {
                        await deleteFactory(row.id)
                        fetchAllFabricas()
                        toast("success", "Fábrica desativada com sucesso!")
                      } catch (error) {
                        toast("warning", "Falha ao desativar Fábrica.")
                        console.log(error)
                      } finally {
                        setIsLoading(false)
                      }
                    },
                  })
                  setShowConfirm(true)
                }
              }}
            >
              <i
                className={`mdi mdi-${
                  row.deletedAt ? "account-reactivate" : "delete-forever"
                }`}
                id={`delToolTip${row.id}`}
              ></i>
            </a>
            <UncontrolledTooltip placement="top" target={`delToolTip${row.id}`}>
              {`${row.deletedAt ? "Reativar" : "Desativar"}`}
            </UncontrolledTooltip>
          </li>
        </ul>
      ),
    },
  ]

  const fetchAllFabricas = async () => {
    try {
      setIsLoading(true)
      const { payload } = await getAllFactoriesParanoid()
      setFabricas(payload)
    } catch (error) {
      console.error(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    fetchAllFabricas()
    // try {
    // } catch (error) {
    //   console.error(error)
    // } finally {
    //   setIsLoading(false)
    // }
  }, [])

  const validaNovaFabrica = () => {
    let errors = []
    if (!novaFabrica?.name) {
      errors.push("Não é possível criar uma fábrica sem nome.")
    }
    if (!novaFabrica?.sla) {
      errors.push("Não é possível criar uma fábrica sem sla.")
    }
    // if (!novaFabrica?.tag) {
    //   errors.push("Não é possível criar uma fábrica sem tag.")
    // }
    if (errors?.length > 0) {
      return errors
    } else {
      return null
    }
  }

  const handleSubmit = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const errors = validaNovaFabrica()
      if (errors) {
        toast("warning", errors.join("<br />"))
        return
      }
      await postNovaFactory(novaFabrica)
      toast("success", "Fábrica adicionada com sucesso!")
      fetchAllFabricas()
      setNovaFabrica({
        name: "",
        // tag: "",
        sla: "",
        slaAlertEnabled: false,
      })
    } catch (error) {
      toast("warning", "Falha ao criar fábrica.")
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const validaUpdatedFabrica = () => {
    let errors = []
    if (!updatedFabrica?.name) {
      errors.push("Não é possível atualizar uma fábrica para sem nome.")
    }
    if (!updatedFabrica?.sla) {
      errors.push("Não é possível atualizar uma fábrica para sem sla.")
    }
    // if (!updatedFabrica?.tag) {
    //   errors.push("Não é possível atualizar uma fábrica para sem tag.")
    // }
    if (errors?.length > 0) {
      return errors
    } else {
      return null
    }
  }

  const handleUpdateFabrica = async e => {
    e.preventDefault()
    setIsLoading(true)
    try {
      const errors = validaUpdatedFabrica()
      if (errors) {
        toast("warning", errors.join("<br />"))
        return
      }
      await updateFactory(updatedFabrica)
      toast("success", "Fábrica atualizada com sucesso!")
      fetchAllFabricas()
      setUpdatedFabrica({
        name: "",
        // tag: "",
        sla: "",
        slaAlertEnabled: false,
      })
      setModalUpdatedFabrica(false)
    } catch (error) {
      toast("warning", "Falha ao atualizar fábrica.")
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <Breadcrumb
            title={props.t("Configurações")}
            breadcrumbItems={[{ title: props.t("Fábricas"), path: "#" }]}
          />
          <Row>
            <Col>
              <Card className="mb-0 border-bottom">
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  {t("Adicionar")}
                </CardHeader>
                <CardBody>
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col sm={6}>
                        <FormGroup>
                          <Label>{t("Nome da Fábrica")}</Label>
                          <Input
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder="Fábrica"
                            disabled={isLoading}
                            value={novaFabrica.name}
                            onChange={e => {
                              setNovaFabrica(old => {
                                return { ...old, name: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      {/* <Col sm={2}>
                        <FormGroup>
                          <Label>{t("Tag")}</Label>
                          <Input
                            name="tag"
                            type="text"
                            className="form-control"
                            placeholder="Tag"
                            disabled={isLoading}
                            value={novaFabrica.tag}
                            onChange={e => {
                              setNovaFabrica(old => {
                                return { ...old, tag: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col> */}
                      <Col sm={2}>
                        <FormGroup>
                          <Label>{t("Sla")}</Label>
                          <Input
                            name="sla"
                            type="number"
                            className="form-control"
                            placeholder="Sla"
                            disabled={isLoading}
                            value={novaFabrica.sla}
                            onChange={e => {
                              setNovaFabrica(old => {
                                return { ...old, sla: e.target.value }
                              })
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm={2}>
                        <br />
                        <br />
                        <FormGroup check>
                          <Input
                            type="checkbox"
                            disabled={isLoading}
                            checked={novaFabrica.slaAlertEnabled}
                            onChange={e => {
                              setNovaFabrica(old => {
                                return {
                                  ...old,
                                  slaAlertEnabled: e.target.checked,
                                }
                              })
                            }}
                          />{" "}
                          <Label check>Alerta Sla?</Label>
                        </FormGroup>
                      </Col>
                      <Col className="d-flex align-items-end">
                        <FormGroup>
                          <Button type="submit">{t("Adicionar")}</Button>
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col>
              <Card>
                <CardHeader tag={"h4"} className="bg-transparent border-bottom">
                  Lista de Fábricas
                </CardHeader>
                <CardBody>
                  {!isLoading &&
                    (fabricas?.length > 0 ? (
                      <ToolkitProvider
                        keyField="id"
                        columns={columns}
                        columnToggle
                        data={fabricas}
                        search
                      >
                        {toolkitProps => (
                          <React.Fragment>
                            <Row>
                              <Col xl="12">
                                <BootstrapTable
                                  keyField={"id"}
                                  bordered={true}
                                  striped={true}
                                  condensed
                                  defaultSorted={defaultSorted}
                                  selectRow={selectRow}
                                  classes={"table align-middle table-nowrap"}
                                  headerWrapperClasses={"thead-light"}
                                  {...toolkitProps.baseProps}
                                />
                              </Col>
                            </Row>
                          </React.Fragment>
                        )}
                      </ToolkitProvider>
                    ) : (
                      <div style={{ textAlign: "center" }}>
                        <h5>Nenhum dado foi encontrado.</h5>
                      </div>
                    ))}
                  {isLoading && (
                    <div
                      className="accordion-body"
                      style={{ textAlign: "center" }}
                    >
                      <Spinner className="ms-2" color="primary" />
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Modal
        isOpen={showConfirm}
        toggle={() => {
          setShowConfirm(!showConfirm)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>{confirm?.title}</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
              {
                confirm
              }
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">{confirm?.body}</div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setShowConfirm(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="button"
            onClick={async () => {
              await confirm?.onConfirm()
              setShowConfirm(false)
            }}
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
      <Modal
        isOpen={modalUpdatedFabrica}
        toggle={() => {
          setModalUpdatedFabrica(!modalUpdatedFabrica)
        }}
        centered
      >
        <div className="modal-header">
          <h5 className="modal-title mt-0" id="myModalLabel">
            <p>Atualizar Status</p>
          </h5>
          <button
            type="button"
            onClick={() => {
              setModalUpdatedFabrica(false)
            }}
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Form onSubmit={handleUpdateFabrica} id="updateFabrica">
            <Row>
              <Col>
                <Label>{t("Novo Nome")}</Label>
                <Input
                  type="text"
                  className="form-control"
                  disabled={isLoading}
                  value={updatedFabrica?.name}
                  onChange={e => {
                    setUpdatedFabrica(old => {
                      return { ...old, name: e.target.value }
                    })
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              {/* <Col>
                <Label>{t("Nova Tag")}</Label>
                <Input
                  type="text"
                  className="form-control"
                  disabled={isLoading}
                  value={updatedFabrica?.tag}
                  onChange={e => {
                    setUpdatedFabrica(old => {
                      return { ...old, tag: e.target.value }
                    })
                  }}
                />
              </Col> */}
              <Col>
                <Label>{t("Novo Sla")}</Label>
                <Input
                  type="text"
                  className="form-control"
                  disabled={isLoading}
                  value={updatedFabrica?.sla}
                  onChange={e => {
                    setUpdatedFabrica(old => {
                      return { ...old, sla: e.target.value }
                    })
                  }}
                />
              </Col>
            </Row>
            <br />
            <Row>
              <Col>
                <Input
                  type="checkbox"
                  disabled={isLoading}
                  checked={updatedFabrica?.slaAlertEnabled}
                  onChange={e => {
                    setUpdatedFabrica(old => {
                      return { ...old, slaAlertEnabled: e.target.checked }
                    })
                  }}
                />{" "}
                <Label check>Alerta Sla?</Label>
              </Col>
            </Row>
          </Form>
        </div>
        <div className="modal-footer">
          <button
            type="button"
            onClick={() => {
              setModalUpdatedFabrica(false)
            }}
            className="btn btn-secondary"
            data-dismiss="modal"
          >
            {t("Cancelar")}
          </button>
          <button
            type="submit"
            form="updateFabrica"
            className="btn btn-primary"
            data-dismiss="modal"
          >
            {t("Confirmar")}
          </button>
        </div>
      </Modal>
    </>
  )
}

Fabricas.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Fabricas)
